import React from "react";
import { Alert } from "@mui/material";
import { useAdminDataGuard } from "../hooks/useAdminDataGuard";
import PatchingCenterConsole from "../components/patchings/PatchingCenterConsole";

const AdminPatchingCenterPage = () => {
  const canAccessAdminData = useAdminDataGuard();

  if (!canAccessAdminData) {
    return <Alert severity='error'>Admin token validation failed.</Alert>;
  }

  return <PatchingCenterConsole />;
};

export default AdminPatchingCenterPage;
